export class DisplayLedger {
}
DisplayLedger.RegisteredControls = {};
//# sourceMappingURL=displayLedger.js.map